// Texty modalu „Možnosti doručenia" — slovenské dvojča locale/cs/shippingModal.js.
export default {
  title: 'Možnosti doručenia',
  sub: 'Ceny a termíny pre tento produkt',
  close: 'Zavrieť',
  done: 'Rozumiem',
  terms: 'Doprava a platba',
  deliver: 'Doručíme',
  pickupEta: 'Vyzdvihnete',
  ship: 'Odošleme',
  orderToday: (cutoff) => 'Ak objednáte dnes do ' + cutoff + ', odošleme ešte dnes',
  countdown: 'do expedície zostáva',
  fastShip: 'už',
  loading: 'Načítavame možnosti doručenia…',
  error: 'Možnosti doručenia sa teraz nepodarilo načítať.',
  promoTag: (until) => 'Akcia do ' + until,
};
